import _extends from '/app/node_modules/babel-runtime/helpers/extends';
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex';

export default {
    // async fetch({ store, redirect, params }) {
    //     if()
    // },
    head: function head() {
        return {
            title: this.$store.state.dashboard.details.toolbarTitle
        };
    },
    data: function data() {
        return {};
    },

    computed: _extends({}, mapGetters({
        filtersLayout: 'dashboard/details/setLayout',
        title: 'dashboard/details/titleTableMobile'
    }), {
        changeTitle: function changeTitle() {
            if (this.$store.state.dashboard.filters.tableNameMobile === 'Process') {
                this.title = 'Afiliaciones en Proceso';
            } else if (this.$store.state.dashboard.filters.tableNameMobile === 'Work') {
                this.title = 'Afiliaciones Trabajadas';
            } else {
                this.title = 'Ranking';
            }
        }
    }),
    methods: {
        closeFilter: function closeFilter() {
            this.$store.commit('dashboard/details/setFilterLayout');
            this.$store.commit('dashboard/details/setFilterComponent');
        }
    },
    mounted: function mounted() {
        window.loading_screen.finish();
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/affiliations.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/app/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/layouts/affiliations.vue
// module chunks = 24